import React from 'react';
import { Check, Star } from 'lucide-react';

const Packages = () => {
  const packages = [
    {
      id: 'new-client',
      name: 'New Client Special',
      price: 380,
      originalPrice: 520,
      popular: true,
      image: '🎁',
      description: 'Get started with 4 personalized training sessions at a special rate. Perfect for new clients looking to begin their fitness journey.',
      features: [
        '4-pack training sessions for new clients',
        'In-person training sessions',
        'Personalized training program',
        'Form and technique assessment',
        'Nutrition guidance included',
        'Flexible scheduling'
      ],
      badge: 'Limited Time Offer',
      link: 'http://Htphysique.myshopify.com/products/gift-phytraining-4-pack'
    },
    {
      id: 'small-group',
      name: 'Small Group Training',
      price: 135,
      originalPrice: 180,
      image: '🏋🏽‍♀️🏋🏾‍♂️🏋🏼‍♀️',
      description: 'Join our small group training sessions for a more affordable yet effective workout experience. Perfect for those who enjoy group motivation.',
      features: [
        'Small group setting',
        'Expert guidance',
        'Motivating atmosphere',
        'Regular schedule',
        'New client discount'
      ],
      link: 'http://Htphysique.myshopify.com/products/group-training-jan-30-to-feb-20'
    },
    {
      id: 'phyt-food',
      name: 'PHYT FOOD Program',
      price: 200,
      image: '🍎',
      description: "Lose 1 inch in your waist line with our four week nutrition coaching program. Learn, simple, sustainable, eating habits for life."
      ,
      features: [
        'Personalized meal plans',
        'Nutrition education',
        'Recipe database',
        'Shopping guides',
        'Ongoing support'
      ],
      link: 'http://Htphysique.myshopify.com/products/phyt-food-2-0'
    },
    {
      id: 'travel-kit',
      name: 'PHYT Travel Kit',
      price: 9.99,
      image: '✈️',
      description: 'Stay mobile and flexible with our 5-minute mobility program. Perfect for busy professionals and travelers.',
      features: [
        'Quick mobility routines',
        'Travel-friendly exercises',
        'Digital access',
        'No equipment needed',
        'Instant access'
      ],
      link: 'https://my.playbookapp.io/coach-ht/programs/phyt-travel-kit-mobility-in-5-min/26819'
    }
  ];

  return (
    <section className="py-16 bg-white" id="packages">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Programs & <span className="text-primary-500">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose from our proven programs designed to get you results faster than traditional methods
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {packages.map((pkg) => (
            <div 
              key={pkg.id} 
              className={`relative rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl ${
                pkg.popular ? 'border-2 border-primary-500 shadow-lg' : 'border border-gray-200 shadow-sm'
              }`}
            >
              {pkg.badge && (
                <div className="absolute top-0 left-0 right-0 bg-primary-500 text-center py-1 text-sm font-bold text-white">
                  {pkg.badge}
                </div>
              )}
              
              <div className={`p-6 ${pkg.badge ? 'pt-8' : ''} flex flex-col h-full`}>
                <div className="text-center mb-4">
                  <div className="text-4xl mb-2">{pkg.image}</div>
                  <h3 className="text-xl font-bold text-gray-900">{pkg.name}</h3>
                  <div className="flex items-center justify-center gap-2 mt-2">
                    {pkg.originalPrice && (
                      <span className="text-gray-500 line-through">${pkg.originalPrice}</span>
                    )}
                    <span className="text-2xl font-bold text-primary-500">${pkg.price}</span>
                  </div>
                </div>

                <p className="text-gray-600 mb-6 text-sm">
                  {pkg.description}
                </p>
                
                <div className="flex-1">
                  <h4 className="font-bold mb-3 text-gray-900">What's Included:</h4>
                  <ul className="space-y-2">
                    {pkg.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <span className="flex-shrink-0 mt-1 text-primary-500">
                          <Check size={16} />
                        </span>
                        <span className="text-gray-700 text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <button 
                  // onClick={() => window.open(pkg.link, '_blank', 'noopener,noreferrer')}
                  onClick={() => {
                    const url = pkg.link + '?t=' + Date.now(); // Add timestamp to bypass cache
                    window.open(url, '_blank', 'noopener,noreferrer');
                  }}
                  className="w-full mt-6 bg-primary-500 text-white py-3 px-6 rounded-xl font-medium hover:bg-primary-600 transition-colors text-center block"
                >
                  Start Today
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-500 mb-4">
            Limited spots available. Offer valid for new clients only.
          </p>
          <a
            href="#contact"
            className="inline-block bg-primary-500 text-white px-8 py-3 rounded-xl hover:bg-primary-600 transition-colors"
          >
            Book Your Sessions Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Packages; 